import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { PortalNewsletterService } from '../../services/portalNewsletter.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../services/sharedService';

const ENABLED_KEY = 'PORTAL_NEWSLETTER_ENABLED';
const HEADING_KEY = 'PORTAL_NEWSLETTER_HEADING';
const BLURB_KEY = 'PORTAL_NEWSLETTER_BLURB';

@Component({
    selector: 'app-portal-newsletter',
    templateUrl: './portal-newsletter.component.html',
    standalone: false,
})
export class PortalNewsletterComponent implements OnInit, AfterViewInit {
    subscribers: any[] = [];
    broadcasts: any[] = [];
    enabled = false;
    heading = '';
    blurb = '';
    broadcastSubject = '';
    broadcastBody = '';
    private adminSettings: any = {};

    constructor(
        private settings: AdminService,
        private newsletterService: PortalNewsletterService,
        private alertService: ToastrService,
        private sharedService: SharedService,
    ) {}

    ngOnInit(): void {
        this.loadSettings();
        this.loadSubscribers();
        this.loadHistory();
    }

    ngAfterViewInit(): void {
        this.sharedService.loadMenuItems('admin');
    }

    get confirmedCount(): number {
        return this.subscribers.filter((s) => s.status === 'confirmed').length;
    }

    canSend(): boolean {
        return this.confirmedCount > 0 && !!this.broadcastSubject.trim() && !!this.broadcastBody.trim();
    }

    loadSettings(): void {
        this.settings.getAdminSettings().subscribe((settings) => {
            this.adminSettings = settings && settings.length > 0 ? settings[0] : {};
            this.enabled = this.adminSettings[ENABLED_KEY] === true;
            this.heading = this.adminSettings[HEADING_KEY] || '';
            this.blurb = this.adminSettings[BLURB_KEY] || '';
        });
    }

    saveSettings(): void {
        const payload: any = { id: this.adminSettings.id };
        payload[ENABLED_KEY] = this.enabled;
        payload[HEADING_KEY] = this.heading;
        payload[BLURB_KEY] = this.blurb;
        this.settings.saveAdminSettings(payload).subscribe((data) => {
            this.adminSettings = data;
            this.alertService.success('Newsletter settings saved');
        });
    }

    loadSubscribers(): void {
        this.newsletterService.listSubscribers().subscribe(
            (subs) => { this.subscribers = subs || []; },
            () => { this.alertService.error('Failed to load subscribers'); },
        );
    }

    deleteSubscriber(subscriber: any): void {
        if (!confirm(`Are you sure you want to delete "${subscriber.email}"?`)) return;
        this.newsletterService.deleteSubscriber(subscriber.id).subscribe(
            () => { this.alertService.success(`${subscriber.email} deleted`); this.loadSubscribers(); },
            () => { this.alertService.error(`Failed to delete ${subscriber.email}`); },
        );
    }

    loadHistory(): void {
        this.newsletterService.broadcastHistory().subscribe(
            (history) => { this.broadcasts = history || []; },
            () => { this.alertService.error('Failed to load broadcast history'); },
        );
    }

    sendBroadcast(): void {
        if (!this.canSend()) return;
        if (!confirm(`Send this newsletter to ${this.confirmedCount} confirmed subscriber(s)?`)) return;
        this.newsletterService.broadcast(this.broadcastSubject, this.broadcastBody).subscribe(
            (result) => {
                this.alertService.success(`Sent to ${result.recipientCount} subscriber(s)`);
                this.broadcastSubject = '';
                this.broadcastBody = '';
                this.loadHistory();
            },
            () => { this.alertService.error('Failed to send broadcast'); },
        );
    }
}
